module.exports = __webpack_public_path__ + "assets/img/c1.ffa8e594.jpg";